import axios from 'axios';
const Token = JSON.parse(localStorage.getItem("token"))

export const LeaveEvent = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/company/leave', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })


export const CompanyEvent = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/company/event', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const FindOneEvent = async (id) =>
    await axios.get(process.env.REACT_APP_API_URL + '/company/holyday/' + id, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })
